var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import browserImageSize from "browser-image-size";
import { injectIntl } from "@irati/utils/lang";
import Loading from "@irati/ui/src/Loading";
import { H2 } from "@irati/ui/src/Headings";
import { Caption, Para } from "@irati/ui/src/Labels";
import { uploadImage } from "@irati/images/services/image";
import getBase64 from "@irati/utils/images/getBase64";
import ErrorText from "@irati/ui/src/ErrorText";
import { FlexRow, FlexColumn, StyledDropzone } from "./styled";
var ImageUploader = /** @class */ (function (_super) {
    __extends(ImageUploader, _super);
    function ImageUploader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            uploadError: undefined,
            load: null
        };
        _this.handleUpload = function (file) {
            var onUploadSuccess = _this.props.onUploadSuccess;
            return uploadImage(file).then(function (uploadedImageURL) {
                if (onUploadSuccess) {
                    onUploadSuccess(uploadedImageURL);
                }
            });
        };
        _this.handleDrop = function (acceptedFile, rejectedFile) {
            var formatMessage = _this.props.formatMessage;
            if (rejectedFile.length > 0) {
                return _this.setState({
                    uploadError: formatMessage({
                        id: "platform.fields.imageUploader.dimensionsError"
                    })
                });
            }
            var _a = _this.props, minDimensions = _a.minDimensions, maxDimensions = _a.maxDimensions;
            var acceptedFileImage = acceptedFile[0];
            getBase64(acceptedFileImage).then(function (base64Image) {
                var load = browserImageSize(base64Image).then(function (size) {
                    if (minDimensions && (size.width < minDimensions.width || size.height < minDimensions.height)) {
                        return _this.setState({
                            uploadError: formatMessage({
                                id: "platform.fields.imageUploader.imageTooSmall"
                            }, { width: minDimensions.width, height: minDimensions.height })
                        });
                    }
                    if (maxDimensions && (size.width > maxDimensions.width || size.height > maxDimensions.height)) {
                        return _this.setState({
                            uploadError: formatMessage({ id: "platform.fields.imageUploader.imageTooBig" }, { width: maxDimensions.width, height: maxDimensions.height })
                        });
                    }
                    return _this.handleUpload(base64Image);
                });
                _this.setState({ load: load, uploadError: undefined });
            });
        };
        _this.generateDimensionsHint = function () {
            var _a = _this.props, minDimensions = _a.minDimensions, maxDimensions = _a.maxDimensions, formatMessage = _a.formatMessage;
            var dimensionsHint;
            if (!minDimensions && !maxDimensions) {
                dimensionsHint = formatMessage({ id: "platform.fields.imageUploader.anyDimensionHint" });
            }
            else {
                var minDimensionHint = minDimensions
                    ? formatMessage({ id: "platform.fields.imageUploader.minDimensionHint" }, { width: minDimensions.width, height: minDimensions.height })
                    : formatMessage({ id: "platform.fields.imageUploader.noMinDimensions" });
                var maxDimensionHint = maxDimensions
                    ? formatMessage({ id: "platform.fields.imageUploader.maxDimensionHint" }, { width: maxDimensions.width, height: maxDimensions.height })
                    : formatMessage({ id: "platform.fields.imageUploader.noMaxDimensions" });
                dimensionsHint = minDimensionHint + " & " + maxDimensionHint;
            }
            return dimensionsHint;
        };
        _this.generateSizeHint = function () {
            var _a = _this.props, maxSizeInMB = _a.maxSizeInMB, formatMessage = _a.formatMessage;
            return maxSizeInMB
                ? formatMessage({ id: "platform.fields.imageUploader.imageSizeLimit" }, { maxSize: maxSizeInMB })
                : formatMessage({ id: "platform.fields.imageUploader.noImageSizeLimit" });
        };
        _this.calculateSizeinBytes = function (sizeInMB) { return sizeInMB * 1024 * 1024; };
        return _this;
    }
    ImageUploader.prototype.render = function () {
        var _a = this.props, title = _a.title, maxSizeInMB = _a.maxSizeInMB, dropZoneText = _a.dropZoneText, hideHint = _a.hideHint, widthInPercent = _a.widthInPercent, formatMessage = _a.formatMessage;
        var _b = this.state, load = _b.load, uploadError = _b.uploadError;
        var dropZoneTranslated = dropZoneText || formatMessage({ id: "platform.fields.imageUploader.dropZoneText" });
        var dimensionsHint = this.generateDimensionsHint();
        var sizeHint = this.generateSizeHint();
        return (React.createElement(React.Fragment, null,
            React.createElement(FlexColumn, null,
                title && (React.createElement(H2, null, title)),
                !hideHint &&
                    (React.createElement(React.Fragment, null,
                        React.createElement(Caption, { flush: true }, dimensionsHint),
                        React.createElement(Caption, { flush: true }, sizeHint))),
                React.createElement(StyledDropzone, { width: widthInPercent, accept: "image/jpg,image/jpeg,image/png", onDrop: this.handleDrop, maxSize: maxSizeInMB ? this.calculateSizeinBytes(maxSizeInMB) : undefined },
                    React.createElement(FlexRow, null,
                        React.createElement(Loading, { load: load },
                            React.createElement(Para, { center: true, flush: true }, dropZoneTranslated)))),
                uploadError && React.createElement(ErrorText, null, uploadError))));
    };
    ImageUploader.defaultProps = {
        minimal: false,
        widthInPercent: 100
    };
    return ImageUploader;
}(Component));
export default injectIntl(ImageUploader);
